export function aplicarMascaraCpfCnpj(valor) {
    if (!valor) {
        return valor;
    }
    
    valor = valor.replace(/\D/g, ""); // Remove caracteres não numéricos

    if (valor.length <= 11) {
        // Aplica máscara de CPF: XXX.XXX.XXX-XX
        valor = valor.replace(/^(\d{3})(\d)/, "$1.$2");
        valor = valor.replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3");
        valor = valor.replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
    } else {
        // Aplica máscara de CNPJ: XX.XXX.XXX/XXXX-XX
        valor = valor.replace(/^(\d{2})(\d)/, "$1.$2");
        valor = valor.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
        valor = valor.replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3/$4");
        valor = valor.replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d)/, "$1.$2.$3/$4-$5");
    }

    return valor;
}